import axios, { CancelTokenSource } from "axios";
import api, { ApiResponse } from "./../api";
import { ProgramLogsFilterModel, ProgramLogsItemModel, ProgramLogsTableInfoModel } from "./programLogsModels";

export const REQUEST_ID: {
    [key: string]: string;
} = {
    GET_RECORDS: "get_programlogs"
};

class ProgramLogsService {
    private source: {
        [key: string]: CancelTokenSource;
    };

    private static instance: ProgramLogsService;

    private constructor() {
        this.source = {};
    };

    static getInstance(): ProgramLogsService {
        if (!ProgramLogsService.instance) {
            ProgramLogsService.instance = new ProgramLogsService();
        }
        return ProgramLogsService.instance;
    };

    public getProgramLogsRecords = async (
        filter: ProgramLogsFilterModel,
        page: number
    ): Promise<ApiResponse<ProgramLogsItemModel>> => {
        this.source[REQUEST_ID.GET_RECORDS] && this.source[REQUEST_ID.GET_RECORDS].cancel();
        this.source[REQUEST_ID.GET_RECORDS] = axios.CancelToken.source();
        return await api.post(
            "dotnet-programs-logs/programlogs",
            { ...filter, page }, // Send the payload in the request body
            {
                cancelToken: this.source[REQUEST_ID.GET_RECORDS].token,
            }
        );
    };

    public getProgramLogsTableInfo = async (): Promise<ApiResponse<ProgramLogsTableInfoModel>> => {
        return await api.get("dotnet-programs-logs/tableinfo?type=program");
    };
};

export default ProgramLogsService;
